import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import NavBar from "./assets/components/NavBar";
import FooterPage from "./assets/components/FooterPage";
import Modal from "./assets/components/Modal";
import UpcomingEvents from "./assets/components/UpcomingEvents";
import StartupForm from "./assets/components/StartupForm";
import FillPage from "./assets/components/FillPage";

import HomePage from "./assets/Pages/HomePage";
import ProgramsPage from "./assets/Pages/ProgramsPage";
import IncubateesPage from "./assets/Pages/IncubateesPage";
import BlogsPage from "./assets/Pages/BlogsPage";
import ArticlePage from "./assets/components/Articlepage";
import CoWorkingPage from "./assets/Pages/CoWorkingPage";
import AdminNav from "./assets/components/AdminNav";
import AdminDashboard from "./assets/components/AdminDashboard";
import ClientDashboard from "./assets/components/ClientDashboard";
import ArticleDashboard from "./assets/components/ArticleDashboard";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function App() {
  const [isApplyModalOpen, setIsApplyModalOpen] = useState(false);
  const [isStartupFormOpen, setIsStartupFormOpen] = useState(false);
  const [isUnavailableOpen, setIsUnavailableOpen] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState("");

  return (
    <Router>
      {/* Routes */}
      <Routes>
        {/* Public Routes with Navbar and Footer */}
        <Route
          path="/*"
          element={
            <>
              <NavBar onApplyClick={() => setIsApplyModalOpen(true)} />
              <Routes>
                <Route
                  path="/"
                  element={<HomePage onApplyClick={() => setIsApplyModalOpen(true)} />}
                />
                <Route path="/programs" element={<ProgramsPage />} />
                <Route path="/incubatees" element={<IncubateesPage />} />
                <Route path="/blogs" element={<BlogsPage />} />
                <Route path="/blogs/:_id" element={<ArticlePage />} />
                <Route path="/coworking" element={<CoWorkingPage />} />
              </Routes>
              <FooterPage onApplyClick={() => setIsApplyModalOpen(true)} />
            </>
          }
        />

        {/* Dashboard Routes without Navbar and Footer */}
        <Route path="/admin-nav" element={<AdminNav />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/article-dashboard" element={<ArticleDashboard />} />
        <Route path="/client-dashboard" element={<ClientDashboard />} />
      </Routes>

      {/* Global Modal */}
      <Modal isOpen={isApplyModalOpen} onClose={() => setIsApplyModalOpen(false)}>
        {/* <UpcomingEvents
          onOpenStartupForm={(event) => {
            setSelectedEvent(event);          //Uncomment if there is an going event
            setIsApplyModalOpen(false);
            setIsStartupFormOpen(true);
          }}
        /> */}
        <FillPage
          onClose={() => {setIsUnavailableOpen(false); setIsApplyModalOpen(true);}}
          initialStartupName={selectedEvent}
          goBack={() => {
            setIsUnavailableOpen(false);
            setIsApplyModalOpen(true);
          }}
        />
      </Modal>

      <Modal isOpen={isStartupFormOpen} onClose={() => setIsStartupFormOpen(false)}>
        <StartupForm
          onClose={() => { setIsStartupFormOpen(false); setIsApplyModalOpen(true); }}
          initialStartupName={selectedEvent}
          goBack={() => {
            setIsStartupFormOpen(false);
            setIsApplyModalOpen(true);
          }}
        />
      </Modal>

      <ToastContainer position="top-right" theme="colored" />
    </Router>
  );
}